import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChartLineFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M4 3.5C4.7797 3.5 5.42045 4.09489 5.49313 4.85554L5.5 5V17.5H20C20.8284 17.5 21.5 18.1716 21.5 19C21.5 19.7797 20.9051 20.4204 20.1445 20.4931L20 20.5H4C3.2203 20.5 2.57955 19.9051 2.50687 19.1445L2.5 19V5C2.5 4.17157 3.17157 3.5 4 3.5ZM20.1934 6.31802C21.5387 6.31802 22.2123 7.94453 21.2611 8.89575L15.692 14.4648C15.0672 15.0897 14.0541 15.0897 13.4293 14.4648L11.0252 12.0607L8.55035 14.5356C7.96458 15.1214 7.01483 15.1214 6.42903 14.5356C5.84324 13.9498 5.84322 13.0001 6.429 12.4143L9.89375 8.94941C10.5186 8.32455 11.5317 8.32454 12.1565 8.94939L14.5607 11.3536L16.7424 9.17183C16.2377 8.93031 15.8891 8.41487 15.8891 7.81802C15.8891 6.98959 16.5607 6.31802 17.3891 6.31802H20.1934Z" })
});
export default SvgChartLineFill;
